var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#99AEBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.5L10.75 14.5V32C10.75 32.663 11.0134 33.2989 11.4822 33.7678C11.9511 34.2366 12.587 34.5 13.25 34.5H30.75C31.413 34.5 32.0489 34.2366 32.5178 33.7678C32.9866 33.2989 33.25 32.663 33.25 32V14.5L29.5 9.5H14.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14.5H33.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19.5C27 20.8261 26.4732 22.0979 25.5355 23.0355C24.5979 23.9732 23.3261 24.5 22 24.5C20.6739 24.5 19.4021 23.9732 18.4645 23.0355C17.5268 22.0979 17 20.8261 17 19.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/ShoppingBag.9fc9dd416f2af3e3de95ec7ef21b2f8d.svg";
export { ForwardRef as ReactComponent };